import { type AxiosInstance } from "axios";

export interface UserProfile {
  firstName: string;
  lastName: string;
  email: string;
}

export const getUserProfile = async (
  axiosInstance: AxiosInstance,
): Promise<UserProfile> => {
  const { data } = await axiosInstance.get("/user");
  return data;
};
